import { isEmpty, map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Paragraph from 'components/Paragraph';
import Strong from 'components/Strong';
import Theme from 'styles/theme';

const PdpSpecs = ({ specs }) => {
  if (isEmpty(specs)) {
    return null;
  }

  return (
    <div className="PdpSpecs">
      <Paragraph>
        <Strong>Specs:</Strong>
      </Paragraph>
      <dl className="PdpSpecs__list">
        {map(specs, ({ fields }, index) => (
          <div className="PdpSpecs__row" key={index}>
            <dt className="PdpSpecs__label">{fields.label}</dt>
            <dd className="PdpSpecs__value">{fields.value}</dd>
          </div>
        ))}
        <style jsx>
          {`
            .PdpSpecs__list {
              background-color: ${Theme.get('colors-grey')};
              padding: ${Theme.get('spacing') * 4}px;
            }

            .PdpSpecs__list:not(:last-child) {
              margin-bottom: ${Theme.get('spacing') * 4}px;
            }

            .PdpSpecs__row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-top: 1px solid ${Theme.get('colors-black-20')};
              font-size: ${Theme.get('font-size-small-px')};
              padding: ${Theme.get('spacing') * 2}px 0;
              line-height: 1;
            }

            .PdpSpecs__row:last-child {
              padding-bottom: ${Theme.get('spacing') * 2}px;
              border-bottom: 1px solid ${Theme.get('colors-black-20')};
            }

            .PdpSpecs__label {
              font-weight: ${Theme.get('font-weight-bold')};
              text-transform: uppercase;
              letter-spacing: 2px;
              white-space: nowrap;
            }

            .PdpSpecs__value {
              text-align: right;
              padding-left: ${Theme.get('spacing') * 2}px;
            }
          `}
        </style>
      </dl>
    </div>
  );
};

PdpSpecs.propTypes = {
  specs: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
};

PdpSpecs.defaultProps = {};

export default PdpSpecs;
